// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1lOVP","label":"Radio_label__PwM32","checkMark":"Radio_checkMark__2YORO","disabled":"Radio_disabled__a30BI"};